import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createStaticVNode("<div class=\"inner-banner\"><div class=\"container\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"banner-content text-center\"><h1>View Resume</h1><span></span></div></div></div></div></div>", 1)
const _hoisted_2 = { class: "job-details-pages pt-120 mb-120" }
const _hoisted_3 = { class: "container" }
const _hoisted_4 = { class: "row g-lg-4 gy-5" }
const _hoisted_5 = { class: "col-lg-8" }
const _hoisted_6 = { class: "my-profile-inner" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_pdf_vuer = _resolveComponent("pdf-vuer")!

  return (_openBlock(), _createElementBlock("div", null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_component_pdf_vuer)
            ])
          ])
        ])
      ])
    ])
  ]))
}